import type { statusOptionsValues } from "@dealer-center/ddc-pages-inventory-config-interface";
import { statusOptionsGetValue } from "@dealer-center/ddc-pages-inventory-config-interface";
import type {
  CheckBoxEventValue,
  InterstateOnChangeEvent
} from "@dealer-center/core-components";
import { CheckBox, Grid } from "@dealer-center/core-components";
import styled from "styled-components";
import { useContext, useState } from "react";
import type { statusInputs } from "..";
import { configItemContext } from "..";
import {
  StyledIconInfoOutline,
  StyledImport,
  StyledImportedText,
  StyledInputWrapper
} from "./styles";

interface PagesInventoryConfigUiConfigDispayInputStringInterface {
  item: statusInputs;
}
const StyledStatusDisplayContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const ConfigStatus = ({
  item
}: PagesInventoryConfigUiConfigDispayInputStringInterface) => {
  const {
    curentConfig,
    setCurrentConfigValue,
    importedConfig,
    selectedConfig
  } = useContext(configItemContext);
  const currentConfigItem = curentConfig[
    item.dataIndex
  ] as statusOptionsValues[];
  const importedConfigItem = importedConfig?.[
    item.dataIndex
  ] as statusOptionsValues[];
  const selectedConfigItem = selectedConfig?.[
    item.dataIndex
  ] as statusOptionsValues[];

  const isUsingImportedValue =
    compareArrays(currentConfigItem, importedConfigItem) &&
    !compareArrays(currentConfigItem, selectedConfigItem);

  const [selectAllCleared, setSelectAllCleared] = useState(false);
  const allConfigItem = statusOptionsGetValue("All");
  const selectAllEnabled: boolean =
    (currentConfigItem.length === 0 ||
      currentConfigItem.includes(allConfigItem)) &&
    !selectAllCleared;

  const handleOptionChange =
    (optionValue: statusOptionsValues) =>
    (e: InterstateOnChangeEvent<CheckBoxEventValue>) => {
      const isChecked = e.target.value?.checked;

      let newValues: statusOptionsValues[];
      if (isChecked) {
        // Add the value if it's checked and not already in the array
        newValues = [...currentConfigItem, optionValue];
      } else {
        // Remove the value if unchecked
        newValues = currentConfigItem.filter(value => value !== optionValue);
      }

      setCurrentConfigValue({
        key: item.dataIndex,
        value: newValues.filter(value => value !== statusOptionsGetValue("All"))
      });
    };

  const isOptionSelected = (value: statusOptionsValues): boolean => {
    if (selectAllEnabled) return true;
    return currentConfigItem.includes(value);
  };

  const toggleSelectAll = () => {
    const newValues = {
      key: item.dataIndex,
      value: []
    };
    setSelectAllCleared(!selectAllCleared);
    setCurrentConfigValue(newValues);
  };

  return (
    <StyledInputWrapper>
      <StyledStatusDisplayContent>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }}>
            <CheckBox
              checked={selectAllEnabled}
              label="Select All"
              value={`inventory-config-${item.dataIndex}-checkbox`}
              onChange={toggleSelectAll}
            />
          </Grid>
          {item.options.map(option => (
            <Grid
              key={option.value}
              size={{ lg: 3, md: 4, sm: 6, xl: 2.4, xs: 12 }}
            >
              <CheckBox
                checked={isOptionSelected(option.value)}
                disabled={selectAllEnabled}
                label={option.label}
                value={`inventory-config-${item.dataIndex}-${option.value}`}
                onChange={handleOptionChange(option.value)}
              />
            </Grid>
          ))}
        </Grid>
      </StyledStatusDisplayContent>
      {isUsingImportedValue && (
        <StyledImport>
          <StyledIconInfoOutline title="Using imported value" />
          <StyledImportedText>Using imported value</StyledImportedText>
        </StyledImport>
      )}
    </StyledInputWrapper>
  );
};

const compareArrays = (
  arr1?: statusOptionsValues[],
  arr2?: statusOptionsValues[]
) => {
  if (!arr1 || !arr2) {
    return false;
  }
  if (arr1.length !== arr2.length) {
    return false;
  }
  for (let i = arr1.length; i--; ) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }
  return true;
};
